export default __webpack_public_path__ + "icon_fail058001.svg";